


import { Table, TableColumnsType } from "antd";
import { BorrowerStatsTableTypes, dailyPrincipalPaidTableColumn } from "../../../../components/Dashboards/Tables/Columns";
interface DpdBucketProps {
  data: any[];
  // loading: boolean;
}


const PricipalPaid = ({ data}:DpdBucketProps)    => {  

     const dailybaseColumns: TableColumnsType<BorrowerStatsTableTypes> = [
        {
          title: "Agent Calls Made",
          dataIndex: "agentCallMade",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "IVR Calls",
          dataIndex: "ivrCalls",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "No. Of Borrowers",
          dataIndex: "totalBorrowers",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "Dunning Notices",
          dataIndex: "dunningNotices",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "Whatsapp Sent",
          dataIndex: "whatsappSent",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "SMS Sent",
          dataIndex: "smsSent",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "Legal Notices",
          dataIndex: "legalNotices",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "Mediation Notices",
          dataIndex: "mediationNotices",
          render: (value) => <span>{value || "-"}</span>,
        },
        {
          title: "Recovered Amount",
          dataIndex: "recoveredAmount",
          render: (value) => <span>{value ? `₹ ${value}` : "-"}</span>,
        },
        {
          title: "MTD Collections (₹)",
          dataIndex: "mtdCollections",
          render: (value) => <span>{value ? `₹ ${value}` : "-"}</span>,
        },
        {
          title: "% Recovery vs OS",
          dataIndex: "recoveryVsOs",
          render: (value) => <span>{value || "-"}</span>,
        },
      ];
    
  

      const dailyPrincipalPaidTableColumn: TableColumnsType<BorrowerStatsTableTypes> = [
        {
          title: "PRINCIPAL PAID",
             dataIndex: "bucket",
          render: (value : any) => <span>{value || "-"}</span>,
        },
        ...dailybaseColumns,
      ];
  return (
 <div className="mt-10">
   <Table
        // loading={isPhonebookPending || isPhonebookRefetching}
        columns={dailyPrincipalPaidTableColumn}
         dataSource={data || []}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
      />
 </div>
  );
};

export default PricipalPaid;